import { createCustomEnum } from "../customEnum";

export type CommissionsPricingMethodsTypes =
	| "absolute"
	| "range"
	| "pass_through";

const CommissionsPricingMethods = createCustomEnum({
	Absolute: {
		value: 0,
		name: "absolute",
		displayName: "Absolute",
	},
	Range: {
		value: 1,
		name: "range",
		displayName: "Range",
	},
	PassThrough: {
		value: 2,
		name: "pass_through",
		displayName: "Pass-Through",
	},
});

export default CommissionsPricingMethods;
